module.exports = __webpack_public_path__ + "ax.svg?ef21fff03de2a83096917ad36689bb72";